/* eslint-disable class-methods-use-this */
/* eslint-disable func-style */
import { Injectable } from '@angular/core';
import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import en from '../../i18n/en';

export const TRANSLATE_STORAGE_KEY = 'ngx-translate-lang';

/**
 * Utility method to get selected language from sessionStorage or browser
 */
export function getSelectedLanguage(translateService: TranslateService): string {
    const storedLanguage: string = sessionStorage.getItem(TRANSLATE_STORAGE_KEY);
    // Check if the language has been stored else if the language wasn't stored, then use browser default if supported
    if (storedLanguage && translateService.getLangs().indexOf(storedLanguage) > -1) {
        return storedLanguage;
    } else if (translateService.getLangs().indexOf(translateService.getBrowserLang()) > -1) {
        return translateService.getBrowserLang();
    }
    // If everything fails, then use default lang
    return translateService.currentLang ?? 'en';
}

export function GenericClass<Props>(): new () => Props {
    return class {
        [key: string]: unknown;
    } as any;
}

function concatIfExistsPath(path: string, suffix: string): string {
    return path ? `${path}.${suffix}` : suffix;
}

function transformObjectToPath<T extends object | string>(
    suffix: string,
    objectToTransformOrEndOfPath: T,
    path = ''
): T {
    return typeof objectToTransformOrEndOfPath == 'object'
        ? Object.entries(objectToTransformOrEndOfPath).reduce((objectToTransform, [key, value]) => {
              objectToTransform[key] = transformObjectToPath(key, value, concatIfExistsPath(path, suffix));

              return objectToTransform;
          }, {} as T)
        : (concatIfExistsPath(path, suffix) as T);
}

@Injectable({
    providedIn: 'root',
})
export class Translations extends GenericClass<typeof en>() {
    constructor() {
        super();
        Object.assign(this, transformObjectToPath('', en));
    }
}
export class CustomTranslateLoader implements TranslateLoader {
    getTranslation(lang: string): Observable<any> {
        console.log('TRANSLATE', lang);
        //this.loadCoreTranslations(lang);
        /* @vite-ignore */
        if (lang == 'en-us') {
            const result = from(import('../../i18n/en-us')).pipe(map(x => x.default));
            //console.log('LANG_RES', result);
            return result;
        } else if (lang == 'en') {
            const result = from(import('../../i18n/en')).pipe(map(x => x.default));
            //console.log('LANG_RES', result);
            return result;
        } else if (lang == 'de') {
            const result = from(import('../../i18n/de')).pipe(map(x => x.default));
            //console.log('LANG_RES', result);
            return result;
        } else if (lang == 'tr') {
            const result = from(import('../../i18n/tr')).pipe(map(x => x.default));
            //console.log('LANG_RES', result);
            return result;
        } else if (lang == 'ru') {
            const result = from(import('../../i18n/ru')).pipe(map(x => x.default));
            //console.log('LANG_RES', result);
            return result;
        } else if (lang == 'kk') {
            const result = from(import('../../i18n/kk')).pipe(map(x => x.default));
            //console.log('LANG_RES', result);
            return result;
        } else if (lang == 'fr') {
            const result = from(import('../../i18n/fr')).pipe(map(x => x.default));
            //console.log('LANG_RES', result);
            return result;
        } else {
            const result = from(import('../../i18n/en')).pipe(map(x => x.default));
            //console.log('LANG_RES', result);
            return result;
        }
    }

    // async loadCoreTranslations(lang: string) {
    //     // Use web pack magic string to only include required locale data
    //     const localeModule = await import(
    //         /* webpackInclude: /(de|en|tr|ru|kk)\.mjs$/ */
    //         `/node_modules/@angular/common/locales/${lang}.mjs`
    //     );
    //     // Set locale for built in pipes, etc.
    //     console.log('GLOBAL_LOCAL_DATA:', lang)
    //     registerLocaleData(localeModule.default);
    // }
}
